<template>
  <section class="song-search">
    <b-field
      label="Find a song"
      class="song-search"
    >
      <div class="input-group">
        <div
          v-if="showTags"
          class="input-group-element minor"
        >
          <b-taginput
            v-model="selectedTags"
            :data="availableTags"
            ellipsis
            autocomplete
            field="name"
            icon="label"
            placeholder="Add a tag"
            @typing="getFilteredTags"
            @input="getAsyncSongs"
          />
        </div>
        <div
          class="input-group-element"
          :class="showTags ? 'major' : 'alone'"
        >
          <b-autocomplete
            rounded
            :data="filteredSongs"
            placeholder="e.g. Alleluia"
            field="title"
            icon="magnify"
            :loading="isFetchingSongs"
            :open-on-focus="true"
            @typing="getAsyncSongs"
            @select="$emit('selectSong', $event)"
          >
            <template slot="empty">
              No results found
            </template>
          </b-autocomplete>
        </div>
      </div>
    </b-field>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { debounce } from "lodash";
export default {
  props: {
    showTags: {
      default: false,
      type: Boolean
    },
    initialTags: {
      default() {
        return [];
      },
      type: Array
    }
  },
  data() {
    return {
      availableTags: [],
      filteredSongs: [],
      selectedTags: [],
      isFetchingSongs: false
    };
  },
  computed: {
    ...mapState(["tags"])
  },
  mounted() {
    this.fetchTags();
    this.selectedTags = this.initialTags.slice(0);
    this.filterSongs();
  },
  methods: {
    filterSongs() {
      this.changeSongsFilter({
        main: this.nameFilter,
        tags: this.selectedTags.map(tag => tag.id)
      });

      this.loadAllSongs().then(resp => {
        this.filteredSongs = resp;
      });
    },

    getFilteredTags(name) {
      this.availableTags = this.tags.list
        .filter(tag => tag.name.toLowerCase().includes(name.toLowerCase()))
        .filter(
          tag => !this.selectedTags.map(t => t.name === tag.name).includes(true)
        );
    },
    getAsyncSongs: debounce(function(name) {
      if (!(typeof name == "string")) {
        name = "";
      }
      this.isFetchingSongs = true;

      this.changeSongsFilter({
        main: name,
        tags: this.selectedTags.map(tag => tag.id)
      });

      this.loadAllSongs()
        .then(data => {
          this.filteredSongs = [];
          data.forEach(item => this.filteredSongs.push(item));
        })
        .catch(error => {
          this.filteredSongs = [];
          throw error;
        })
        .finally(() => {
          this.isFetchingSongs = false;
        });
    }, 500),
    ...mapActions(["fetchTags", "changeSongsFilter", "loadAllSongs"])
  }
};
</script>

<style>
.song-search {
  display: block !important;
}
.input-group-element {
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// SearchSong.vue?6d0d0655